/**
 * NumberedList — editorial ordered list: Georgia serif crimson numerals over
 * hairline dividers. (Reworked from the navy-bordered filled-counter
 * "Dummies" grammar.) Used in Bottom Line and cheat-sheet blocks.
 */

export default function NumberedList({
  items,
  accent = "var(--ppr-color-accent-coral)",
}) {
  return (
    <ol
      style={{ listStyle: "none", margin: "10px 0", padding: 0 }}
      data-component="NumberedList"
    >
      {items.map((item, i) => (
        <li
          key={i}
          style={{
            display: "grid",
            gridTemplateColumns: "28px 1fr",
            gap: 14,
            padding: "11px 0",
            borderBottom:
              i < items.length - 1
                ? "1px solid var(--ppr-color-border-default)"
                : "none",
            alignItems: "start",
          }}
        >
          <div
            style={{
              fontFamily: "var(--ppr-typography-font-family-display)",
              fontSize: "20px",
              lineHeight: 1,
              color: accent,
              flexShrink: 0,
              paddingTop: 1,
            }}
          >
            {i + 1}
          </div>
          <div
            style={{
              fontFamily: "var(--ppr-typography-font-family-body)",
              fontSize: "15px",
              lineHeight: "var(--ppr-typography-line-height-loose)",
              color: "var(--ppr-color-text-primary)",
            }}
          >
            {item}
          </div>
        </li>
      ))}
    </ol>
  );
}
